import { BillItem, DISCOUNT_TYPE, KITCHEN_ITEM_STATUS } from '../../all-types'

export const defaultBIDiscounts = {
  amountAfterDiscount: 0,
  amountBeforeDiscount: 0,
  discountComponent: {
    applicableDiscount: 0,
    discountType: DISCOUNT_TYPE.PERCENTAGE,
    isActive: true,
    startDate: "",
    endDate: "",
  },
  discountAmount: 0,
  discountsInfo: [],
  isDiscountApplied: false,
}

export const defaultBillItem: BillItem = {
  productId: "",
  sno: new Date().getTime(),
  yearSno: "",
  itemName: "",
  itemImage: "",
  itemPrice: 0, //new
  totalExtrasPrice: 0, //new
  finalPrice: 0, //new
  quantity: 0,
  mrp: 0,
  amount: 0,
  noOfItems: 1,
  quantityType: "",
  quantityTypeShort: "",
  rateCardName: "",
  default: {
    defaultPrice: 0,
    defaultQuantityType: "",
    defaultQuantityTypeShort: "",
  },
  billingInfo: {
    discounts: defaultBIDiscounts,
    tax: {
      amountAfterTax: 0,
      amountBeforeTax: 0,
      isTaxApplied: true,
      taxAmount: 0,
      taxInfo: [],
    },
    finalAmount: 0,
    rawAmount: 0,
    totalDiscountGiven: 0,
    totalTaxCharged: 0,
  },
  kitchInfo: {
    status: KITCHEN_ITEM_STATUS.IN_CART,
    itemReadyTime: "",
    itemReceviedTime: "",
    kitchenId: "",
    kitchenInstrcutions: "",
    itemServedTime: "",
  },
  extras: {},
};